import React, { useState } from "react";
import { connect } from "react-redux";
import { Modal, ModalBody } from "reactstrap";
import UpdateDutyRoaster from './UpdateDutyRoaster';
import PndRestApi from "src/utils/pnd/PndRestApi";
import { showNotification, successNofication } from "src/shared/components/Notification";
import { useEffect } from "react";
import { ERROR_MESSAGES } from "src/utils/pnd/PndConstants";
const HubModal = ({ modalShow, setModalShow, isTitle, dataInfo,setIsRedirect }) => {
    const [riderDutyRoasterDetails, setRiderDutyRoasterDetails] = useState([]);
    const [isApiError, setApiError] = useState(false);
    const [loading, setLoading] = useState(false);
    let Icon;

    const toggle = () => {
        setModalShow(prevState => !prevState)
    }

    useEffect(() => {
        getRiderDutyRoasterById();

    }, []);

    const handleSubmit = async (formValues) => {
        try {

            const response = await PndRestApi.AddOrUpdateHubDetails(formValues);
            if (response.status === 200 && response.data.status === 200) {
                successNofication(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    ERROR_MESSAGES.successMessage,
                );
                setIsRedirect(true);
            } else {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    `Message:${response.data.message}`,
                );
            }
        } catch (error) {
            showNotification(
                "theme-light",
                "ltr",
                `SuccessCode: 500`,
                ERROR_MESSAGES.tryCatchError,
            );
        }
    };

    const getRiderDutyRoasterById = async () => {
        try {
            setLoading(true);
            const response = await PndRestApi.GetRiderDutyRoasterById(dataInfo?.riderId);
            if (response.status === 200 && response.data.status === 200) {
                setRiderDutyRoasterDetails(response?.data?.data);
            } 
        } catch (error) {
            console.error('Error fetching data:', error);
            showNotification(
                "theme-light",
                "ltr",
                `SuccessCode: 500`,
                ERROR_MESSAGES.tryCatchError,
            );
        } finally {
            setLoading(false);
        }
    };
    return (
        <div >
            <Modal
                isOpen={modalShow}
                toggle={toggle}
                modalClassName={`ltr-support`}
                className="theme-light ltr-support credit-memo-modal-form-ani">
                <div className="modal__header">
                    <button
                        className="lnr lnr-cross modal__close-btn"
                        aria-label="modal__close-btn"
                        type="button"
                        onClick={toggle}
                    />
                    {Icon}
                    <h4
                        className="text-modal  modal__title mt-1 text-uppercase"

                    >
                        {isTitle}
                    </h4>
                </div>
                <ModalBody className="m-0">
                    <div className="credit-memo-modal-form-ani">
                        {/* <span className="account__logo">
                            <span
                                className="account__logo-accent text-light"> */}
                                {/* form  */}
                                {dataInfo  && riderDutyRoasterDetails.length>0?
                                    <UpdateDutyRoaster
                                        title="User Details" onSubmit={handleSubmit} dataInfo={dataInfo} 
                                        riderDutyRoasterDetails={riderDutyRoasterDetails} setIsRedirect= {setIsRedirect}

                                    /> :
                                    <UpdateDutyRoaster dataInfo={dataInfo} riderDutyRoasterDetails={riderDutyRoasterDetails} setIsRedirect= {setIsRedirect}

                                    />
                                }
                            {/* </span>
                        </span> */}
                    </div>
                </ModalBody>
            </Modal>
        </div>
    );
};


export default connect((state) => ({
    rtl: state.rtl,
}))(HubModal);
